import { getState, execChangeHandler, generateLink } from './service'

/**
 * @returns {Object}
 * @description Returns a router obect, that matches the vue-router API
 * we are only implementing the createHref and push methods, since we
 * can't really implement the rest of the API with the anuglar router.
 */
export const useRouter = () => {
  return {
    /**
     * @param {String} to - The route name
     * @param {*} params - The route params
     * @returns {String}
     * @description Returns a link for the given route name and params
     */
    createHref: (to, params) => {
      return generateLink({ name: to, params })
    },

    /**
     * @param {String} to - The route name
     * @param {*} params - The route params
     * @returns {void}
     * @description Pushes a new route to the router
     */
    push: (to, params) => {
      return execChangeHandler({ name: to, params })
    },
  }
}

/**
 * @returns {Object}
 * @description Returns the current route
 */
export const useRoute = () => {
  return getState()
}
